<template>
    <a-modal :title="$t('project.createSandbox')" :centered="true" :maskClosable="false" :visible="createSandVisible" @cancel="handleCancel" :bodyStyle="{'padding-bottom':0}">
        <a-form-model class="form" ref="createSandForm" :model="form" :rules="rules" v-bind="formItemLayout">
            <a-form-model-item class="logger-form-tips" :label="$t('project.sandboxName')" prop="name">
                <a-input 
                :placeholder="$t('project.pleaseInputSandboxName')"
                v-model="form.name" 
                ref="input" 
                allowClear
                ></a-input>
            </a-form-model-item>
            <a-form-model-item class="logger-form-tips" :label="$t('project.tags')" prop="labelIdList">
                <a-select mode="tags" v-model="form.labelIdList" style="width: 100%" :placeholder="$t('project.pleaseInputTags')" @change="handleChange">
                  <a-select-option v-for="item in oldLabelList" :key="`${item.labelId}`">
                    {{ item.labelName }}
                  </a-select-option>
                </a-select>
            </a-form-model-item>
        </a-form-model>
        <div class="modal-footer" slot="footer">
            <a-button class="cancelBtnClass" @click="handleCancel">{{$t('base.cancel')}}</a-button>
            <a-button @click="handleCreateOk" type="primary"> {{$t('base.confirm')}} </a-button>
        </div>
    </a-modal>
</template>

<script>
import { addSand, getLabelListApi } from '@/api/workbench'
export default {
  name: 'CreateSandModal',
  props: {
    createSandVisible: {
      type: Boolean,
      default: false
    },
    templateInfo: {
        type: Object,
        default: () => {}
    }
  },
  data() {
    return {
        form: {
            name: '',
            labelList: [],
            labelIdList: []
        },
        formItemLayout: {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        },
        oldLabelList: []
    }
  },
  computed: {
    userId() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      return userInfo.applyAccount || userInfo.userId || null
    },
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('project.pleaseInputSandboxName'),
            trigger: ['blur'],
          },
          {
            pattern: /^(?!_)[\u4e00-\u9fa5A-Za-z0-9_]{1,50}$/,
            message: this.$t('project.sandboxNameRules', [50]),

            trigger: ['change','blur'],
          },
        ],
      }
    },

  },
  watch: {
    createSandVisible(val) {
      if (val) {
        this.getLabelList()
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    templateInfo: {
      handler(val) {
        if (Object.keys(val).length) {
        debugger
          this.form.name = val.name
        }
      }
    }
  },
  methods: {
    async getLabelList() {
      try {
        const res = await getLabelListApi({})
        if(res.code === 200) {
          this.oldLabelList = res.data || []
        }
      } catch (error) {
        
      }
    },
    handleChange(val) {
      this.form.labelList = val
    },
    // 重置表单
    resetForm() {
      this.form.labelList = []
      this.$refs.createSandForm.resetFields() // 再重置字段
    },
    
    // 在关闭弹窗时重置表单
    handleCancel() {
        this.$emit('update:createSandVisible', false)
        this.resetForm()
    },
    
    // 在创建成功后重置表单
    async handleCreateOk() {
      await this.$refs.createSandForm.validate()
      try {
        const payload = {
          account: this.userId,
          sandName: this.form.name,
          labelList: this.form.labelList,
        }
        const res = await addSand(payload)
        if(res.code === 200 || res.status === 0){
          if (res.data.hasSameProject) {
            this.$message.error(this.$t('project.sandboxNameExist'))
            return
          }
          this.$message.success(this.$t('project.createSandboxSuccess'))
          this.$emit('update:createSandVisible', false)
          this.resetForm() // 重置表单
          this.$emit('refreshSandList')
        }
      } catch (error) {
        console.error(error)
      }
    },
  }
}
</script>

<style lang="less" scoped>

</style>
